import { useCallback, useEffect, useState } from 'react';
import i18next from 'i18next';

export default () => {
    const [language, setLanguage] = useState<string>('');

    useEffect(() => {
        i18next.on('languageChanged', setLanguage);

        return () => {
            i18next.off('languageChanged', setLanguage);
        };
    }, []);

    const i18next_t = useCallback((key, options?) => i18next.t(key, options), [language]);

    return i18next_t;
};
